require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Instagram = void 0;

var _react = _interopRequireDefault(require("react"));

var _generalObserver = require("../general-observer");

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Instagram = function Instagram(_ref) {
  var instagramId = _ref.instagramId;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleInstagrmLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("blockquote", {
    className: "instagram-media instagram-mdx-embed",
    "data-instgrm-version": "12"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://instagram.com/p/".concat(instagramId)
  }, typeof window !== 'undefined' && !window.instgrm ? 'Loading' : '')));
};

exports.Instagram = Instagram;